import { api } from '../../api';
import { useMutation, UseMutationResult } from 'react-query';
import queryClient from '../../query-client';
import { AxiosError } from 'axios';
import { useFirmContext } from '../../providers/FirmProvider';

export type DeletePaymentMethodRequest = {
    paymentMethodId: string;
};

async function deletePaymentMethod(req: DeletePaymentMethodRequest, firmId: string): Promise<void> {
    const { data } = await api.delete(`/firms/${firmId}/subscription/v2/payment-methods/${req.paymentMethodId}`);
    return data;
}

export function useDeletePaymentMethod(): UseMutationResult<void, AxiosError, DeletePaymentMethodRequest, unknown> {
    const { id } = useFirmContext();
    return useMutation((req) => deletePaymentMethod(req, id), {
        onMutate: async (req) => {
            await queryClient.cancelQueries(['payment-methods']);
            const previous = queryClient.getQueryData(['payment-methods']);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            queryClient.setQueryData(['payment-methods'], (old: any) => ({
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                paymentMethods: old.paymentMethods.filter((pm: any) => pm.id !== req.paymentMethodId),
            }));
            return previous;
        },

        onError: (_, __, previous) => {
            queryClient.setQueryData(['payment-methods'], previous);
        },
        onSettled: () => {
            queryClient.invalidateQueries(['payment-methods']);
        },
    });
}
